"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
var DEFAULT_SIZES = {
    mobile: constants_1.Breakpoint.SM,
    tablet: constants_1.Breakpoint.MD,
    desktop: constants_1.Breakpoint.LG,
    desktopXl: constants_1.Breakpoint.XL,
    default: constants_1.Breakpoint.MD,
};
var getSizes = function (options) {
    var sizes = options.sizes, width = options.width;
    if (!sizes && !width) {
        return DEFAULT_SIZES;
    }
    if (typeof width === 'number') {
        return { default: width };
    }
    if (!sizes.hasOwnProperty('default')) {
        var allSizes = Object.values(sizes).filter(function (size) { return typeof size === 'number'; });
        return __assign(__assign({}, sizes), { default: Math.min.apply(Math, __spreadArray([], __read(allSizes))) });
    }
    return sizes;
};
exports.default = getSizes;
//# sourceMappingURL=getSizes.js.map